export const parts: { [key: string]: string[] } = {
  icon: ['base'],
  skeleton: ['base', 'part-default'],
  'breadcrumbs-item': [
    'base',
    'mobile-action',
    'icon',
    'text',
    'part-default',
    'separator-wrapper',
    'part-separator',
    'default-separator',
    'link',
    'before-wrapper',
    'part-before',
    'link-text',
    'after-wrapper',
    'part-after',
    'label-button',
    'show-more-wrapper',
    'show-more',
    'separator-wrapper',
    'separator',
    'default-separator',
    'part-custom-link'
  ],
  list: ['base', 'list', 'part-default'],
  'list-item': [
    'base',
    'link',
    'body',
    'icon',
    'part-before',
    'text',
    'part-default',
    'highlighted',
    'after-wrapper',
    'part-after',
    'icon-right',
    'icon-down',
    'items-wrapper',
    'panel',
    'part-items',
    'items-wrapper',
    'part-custom-link'
  ],
  tooltip: ['base', 'wrapper', 'part-trigger', 'content', 'part-default', 'arrow'],
  button: ['button', 'base', 'before-wrapper', 'part-before', 'text', 'part-default', 'after-wrapper', 'part-after', 'part-custom-link'],
  'field-note': ['base', 'part-default'],
  popover: [
    'base',
    'part-trigger',
    'panel-wrapper',
    'panel',
    'header-wrap',
    'header-content',
    'part-heading',
    'part-header',
    'close-button',
    'close-button-icon',
    'body',
    'part-default',
    'footer-wrapper',
    'part-footer'
  ],
  'input-field': [
    'base',
    'label-skeleton',
    'body-loader',
    'body-skeleton',
    'field-note-loader',
    'field-note-skeleton',
    'wrapper',
    'body',
    'input-field',
    'label-wrapper',
    'label-container',
    'label-inner-wrapper',
    'part-label',
    'part-required',
    'part-word-count',
    'max-length',
    'status-icon',
    'part-after',
    'before',
    'part-char-insert-before',
    'part-char-insert-after',
    'footer',
    'field-notes',
    'field-note-wrapper',
    'part-field-note',
    'part-warning',
    'part-error'
  ],
  modal: [
    'base',
    'window',
    'header',
    'back-button',
    'back-before',
    'header-wrapper',
    'part-heading',
    'part-header',
    'part-actions',
    'close-button',
    'close-after',
    'body',
    'part-default',
    'footer-wrapper',
    'part-footer'
  ],
  'text-passage': ['base', 'part-default'],
  'textarea-field': [
    'base',
    'label-container',
    'md-label-loader',
    'md-label-skeleton',
    'max-length-loader',
    'max-length-skeleton',
    'loader',
    'skeleton-loader',
    'field-note-loader',
    'field-note-skeleton',
    'header',
    'label-wrap',
    'label-inner-wrapper',
    'part-label',
    'part-required',
    'part-word-count',
    'max-length',
    'container',
    'body',
    'wrapper',
    'status-icon',
    'part-after',
    'input',
    'footer',
    'field-note-wrap',
    'part-field-note',
    'part-warning',
    'part-error'
  ],
  'dropdown-panel': ['base', 'header-wrapper', 'part-header', 'body', 'part-default', 'footer-wrapper', 'panel-footer'],
  'file-upload': [
    'base',
    'part-label',
    'label-text',
    'body',
    'input',
    'text',
    'part-default',
    'description-wrapper',
    'upload-icon',
    'description',
    'upload-button',
    'small-table',
    'table-wrapper',
    'table-item',
    'name-container',
    'document-filled-icon',
    'item-text',
    'item-second',
    'uploading-wrapper',
    'uploading-icon',
    'uploading-text',
    'success-wrapper',
    'success-icon',
    'success-text',
    'remove-status-wrapper',
    'close-circle-icon',
    'status-text',
    'item-third',
    'close-button',
    'file-upload-table',
    'upload-list',
    'item-header',
    'header-row',
    'first-title',
    'second-title',
    'third-title',
    'upload-list-body',
    'item-wrapper',
    'item-first',
    'field-note-wrapper',
    'part-field-note',
    'part-error',
    'part-warning',
    'warning-icon'
  ],
  'time-selector-list': ['base', 'top', 'heading', 'inner', 'list', 'item', 'button'],
  calendar: [
    'base',
    'header',
    'previous-nav',
    'part-before',
    'triangular-left-icon',
    'month-button',
    'chevron-down-icon',
    'next-nav',
    'part-after',
    'triangular-right-icon',
    'table-container',
    'table',
    'table-header',
    'week-table-row',
    'header-cell',
    'table-body',
    'day-table-row',
    'table-cell',
    'day',
    'month-popup',
    'month-selector',
    'month-list',
    'month-selector_item',
    'month-selector-year',
    'month-selector_sub-list',
    'month-selector_sub-item',
    'month-selector_button',
    'abbr'
  ],
  'combined-input': ['base', 'wrapper', 'start-input-container', 'start-input', 'start-after', 'end-input-container', 'end-input', 'end-after'],
  chip: [
    'base',
    'part-select',
    'check-icon',
    'label',
    'part-default',
    'close-wrapper',
    'wrapper',
    'part-close',
    'close-icon',
    'skeleton',
    'loader',
    'loader-body'
  ],
  'image-grid': ['base', 'part-default'],
  'image-grid-item': ['base', 'link', 'part-default'],
  'loading-indicator': ['base'],
  heading: ['base', 'part-default', 'heading-wrapper', 'before-wrapper', 'part-before'],
  'contextual-menu': ['base', 'part-trigger', 'dropdown-panel', 'part-default'],
  'pagination-item': ['base', 'link', 'part-default'],
  'checkbox-field': [
    'base',
    'container',
    'input',
    'custom-wrapper',
    'custom-check',
    'part-label',
    'part-default',
    'part-required',
    'loader',
    'field-note-loader',
    'field-note-skeleton',
    'field-note-wrapper',
    'part-field-note',
    'part-warning',
    'part-error',
    'error-icon',
    'warning-icon',
    'highlight'
  ],
  table: ['base', 'caption-wrap', 'part-caption', 'part-default'],
  'table-body': ['base', 'part-default'],
  'table-row': ['base', 'wrap', 'part-default'],
  'table-header': ['base', 'part-default'],
  'table-header-cell': [
    'base',
    'skeleton',
    'checkbox',
    'button',
    'heading',
    'sort-icon',
    'title',
    'part-default',
    'icon-chevron-down',
    'description-wrapper',
    'part-description',
    'dropdown-panel',
    'part-filter',
    'list',
    'ascending',
    'descending',
    'filter-by',
    'sort-label'
  ],
  'table-cell': [
    'base',
    'skeleton',
    'expandable-button',
    'icon-chevron-down',
    'draggable-button',
    'icon-drag-reorder',
    'checkbox',
    'title',
    'part-default',
    'view-button',
    'icon-chevron-right'
  ],
  'table-object': [
    'base',
    'header-wrapper',
    'part-header',
    'tooltip',
    'body',
    'bulk-action',
    'bulk-action-title',
    'bulk-action-buttons',
    'part-bulkActionSingle',
    'part-bulkAction',
    'bulk-action-more',
    'more-trigger',
    'icon-delta-down',
    'part-bulkActionSingleMore',
    'part-bulkActionMore',
    'bulk-action-close',
    'icon-close',
    'body-inner',
    'part-default',
    'footer-wrapper',
    'part-footer',
    'modal',
    'modal-heading',
    'modal-body',
    'cellHeading-item-mobile',
    'cellHeading-text',
    'cellHeading-innerText',
    'cellHeading-innerHTML',
    'self-foldable-item',
    'self-foldable-item-text',
    'self-foldable-item-innerText',
    'self-foldable-item-innerHTML',
    'isExpandableNestedChild-row',
    'isExpandableChild-row',
    'isExpandableNestedChild-cell',
    'isExpandableChild-cell'
  ],
  dropdown: [
    'base',
    'label-loader',
    'label-skeleton',
    'body-loader',
    'body-skeleton',
    'field-note-loader',
    'field-note-skeleton-wrap',
    'field-note-skeleton',
    'label-wrapper',
    'part-label',
    'part-required',
    'container',
    'header-content',
    'body',
    'input-wrap',
    'select',
    'dropdown-before-icon',
    'part-before',
    'text-container',
    'chip',
    'text',
    'icon-wrapper',
    'cross-icon',
    'icon-after',
    'separator',
    'separator-line',
    'status-icon',
    'arrow-icon',
    'panel-component',
    'part-default',
    'field-note-wrapper',
    'part-field-note',
    'part-error',
    'warning'
  ],
  'grid-item': ['base', 'part-default'],
  card: ['base', 'header-wrapper', 'part-header', 'body', 'part-default', 'footer-wrapper', 'part-footer'],
  'primary-nav-item': [
    'base',
    'link',
    'icon-before',
    'part-before',
    'icon-after',
    'part-after',
    'part-icon',
    'icon-down',
    'panel',
    'panel-inner',
    'part-default',
    'part-custom-link',
    'dropdown-panel'
  ],
  'text-link': ['base', 'part-default', 'after', 'link-after', 'part-custom-link'],
  drawer: [
    'base',
    'panel',
    'hide-button',
    'button-after-icon',
    'header-wrapper',
    'header-content',
    'part-header',
    'part-actions',
    'close-button',
    'close-button-after-icon',
    'bottom-wrapper',
    'bottom-wrapper',
    'body',
    'part-default',
    'footer-wrapper',
    'part-footer'
  ]
};
